import { CameraGroupFeature } from '@app/modules/cop/drawing/features/camera-group/camera-group.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class CameraGroupLayerRenderer extends StandardLayerRenderer {
  protected Feature = CameraGroupFeature;
}
